var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 go-back text-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.hasHistory() ? _vm.$router.go(-1) : _vm.$router.push('/')}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }